import { Address } from "../../../../../features/address"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { Customer, useCustomerService } from "../../../../sales"
import { useDeliveryOrderService } from "../../../services/deliveryOrderService"
import { DeliveryData } from "../../../state/types"
import { DeliveryItemRow } from "../../types"

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()
    const { closeModal } = useUIActions()

    const { emitDeliveryOrder } = useDeliveryOrderService()
    const { updateCustomerProps } = useCustomerService()

    const submitCustomerDeliveryAddress = (
        customer: Customer,
        address: Address
    ) => {
        const deliveryAddresses = customer.deliveryAddresses.concat(address)
        return updateCustomerProps(customer.id, { deliveryAddresses })
    }

    const emitDelivery = async (
        table: TableName,
        operationId: string,
        deliveryData: Partial<DeliveryData>,
        itemsData: DeliveryItemRow[]
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const deliveryOrderData = {
            table,
            operationId,
            method: deliveryData.method,
            deliveryDate: deliveryData.deliveryDate,
            addressId: deliveryData.addressId
        }
        const deliveryOrderItemsData = itemsData
            .filter(item => item.quantity > 0)
            .map(item => ({
                itemId: item.itemId,
                quantity: item.quantity
            }))
        try {
            await emitDeliveryOrder(deliveryOrderData, deliveryOrderItemsData)

            Emitter.emit(
                Event.DB_SUBMIT_DONE,
                true,
                false,
                getRoutePath(table === TableName.SALE_ORDERS ? RoutePath.SALES : RoutePath.HOARDS, operationId)
            )
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo emitir la entrega.')
        }
    }

    return {
        submitCustomerDeliveryAddress,
        emitDelivery
    }
}
